/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Teams permissions granted in the domain
 */
export type PublicDomainTeamPermissionDto = {
    /**
     * Domain role assigned to the referenced team for accessing domain
     */
    domainRole: PublicDomainTeamPermissionDto.domainRole;
    /**
     * Id of the team
     */
    teamId: string;
};

export namespace PublicDomainTeamPermissionDto {

    /**
     * Domain role assigned to the referenced team for accessing domain
     */
    export enum domainRole {
        EDITOR = 'EDITOR',
        MONITOR_RESPONDER = 'MONITOR_RESPONDER',
        CATALOG_EDITOR = 'CATALOG_EDITOR',
        VIEWER = 'VIEWER',
    }


}
